module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?> <svg width=16px height=22px viewBox=\"0 0 16 22\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <path d=\"M8,3 L8,0 L4,4 L8,8 L8,5 C11.31,5 14,7.69 14,11 C14,12.01 13.75,12.97 13.3,13.8 L14.76,15.26 C15.54,14.03 16,12.57 16,11 C16,6.58 12.42,3 8,3 Z M8,17 C4.69,17 2,14.31 2,11 C2,9.99 2.25,9.03 2.7,8.2 L1.24,6.74 C0.46,7.97 0,9.43 0,11 C0,15.42 3.58,19 8,19 L8,22 L12,18 L8,14 L8,17 Z\" fill-rule=nonzero></path> </svg>";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/sync.svg
// module id = 297
// module chunks = 0